import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const blockStyles = ({ cellWidth, fullHeight }) => css`
  ${cellWidth &&
  `
    width: ${cellWidth}px;
    min-width: ${cellWidth}px;
  `};
  ${fullHeight && 'height: 100%;'}
`;

export const StyledCell = styled(Flexer.Parent).attrs(() => ({
  justifyContent: 'center',
  flexDirection: 'column',
  pLeft: 'S',
  pRight: 'S',
}))`
  ${blockStyles}
  background-color: #fff;
  border-right: 1px solid var(--greyMouse);
`;

export const StyledLabel = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledSubLabel = styled(Flexer.Parent).attrs(() => ({ alignItems: 'center' }))`
  color: var(--greyWolf);
  white-space: nowrap;
`;

export const CargoItem = styled.span`
  margin-right: 1.6rem;
`;
